import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54026590&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54026590&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54026590",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/index.vue
// module id = U7/T
// module chunks = 0